import { FC, useContext } from 'react';
import { PageContext } from '@namespace/cms';
import { ATextSizeProps } from '@namespace/uikit';
import { OUGTax } from './OUGTax';
import { TaxWithCurrency } from './TaxWithCurrency';
import { UATax } from './UATax';
import { Wrapper } from './Wrapper';

const taxComponentsMap = {
  OUGTax,
  UATax,
  // TODO: make sure we still need keep this kind of tax component
  CurrencyTax: TaxWithCurrency
} as const;

interface TaxProps {
  withAccordion?: boolean;
  wrapperClassNames?: { [key: string]: string };
  textSize?: ATextSizeProps;
}

export const Tax: FC<TaxProps> = ({
  withAccordion = false,
  wrapperClassNames,
  textSize,
  ...props
}) => {
  const {
    page = {}
  }: {
    page?: {
      pageConfig?: {
        taxComponent?: string;
      };
    };
  } = useContext(PageContext); // TODO: remove types once they'll be added to the store
  const { pageConfig = {} } = page;
  const { taxComponent = '' } = pageConfig;
  const TaxComponent =
    taxComponentsMap[taxComponent as keyof typeof taxComponentsMap];

  return TaxComponent ? (
    <Wrapper
      withAccordion={withAccordion}
      classNames={wrapperClassNames}
      textSize={textSize}
    >
      <TaxComponent textSize={textSize} {...props} />
    </Wrapper>
  ) : null;
};
